export default {
    props: {
        meta: {type: Object, default: null},
        useQuery: {type: Boolean},
        hideHeader: {type: Boolean},
        noCreate: {type: Boolean},
    },

    computed: {
        isLoading() {
            return this.api.isLoading;
        },

        canCreate() {
            return !this.noCreate
                && this.api.canAdd();
        },

        isEmpty() {
            return this.items.length === 0;
        },

        total() {
            return this.pagination && this.pagination.total
                || this.items.length;
        },

        currentPage() {
            return this.pagination && this.pagination.current_page || 1;
        },

        lastPage() {
            return this.pagination && this.pagination.last_page || 1;
        },
    },

    mounted() {
        if (this.isEmpty && this.currentPage > 1) {
            this.load(1);
        }
    },

    methods: {
        async load(page) {
            try {
                const results = await this.loadItemsFromApi({page: page || this.currentPage});

                this.items = results.collection;
                this.pagination = results.meta;

                this.$emit('loaded');
            } catch (reason) {
                this.$debugError(reason, this.$options.name, 'load');

                this.$toastr.error(this.$t('notifications.errors.load-data'));

                if (!reason) {
                    this.$toastr.error('notifications.errors.unauthorized');
                    this.$navigateTo('/', 500);

                    return;
                }

                if (reason && reason.errors && Array.isArray(reason.errors._errors)) {
                    reason.errors._errors.forEach((message) => this.$toastr.error(message));
                }

                this.$forceReload(500);
            }
        },

        loadItemsFromApi(params) {
            return this.api.index(params);
        },

        handleAdd() {
            this.$navigateTo(this.api.create());
        },
    },
};
